import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { profileAll } from "../apis/api/DashboardApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ChatSidebar = ({ new_message, chatlist, onSelectMember }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [acknowledgedMessages, setAcknowledgedMessages] = useState([]);
  const [activeChatId, setActiveChatId] = useState(null); 
  const [visiblesearch, setvisiblesearch] = useState(false);
  const visibleref = useRef(null);

  const handleClickOutside = (event) => {
    if (visibleref.current && !visibleref.current.contains(event.target)) {
      setvisiblesearch(false);
    }
  };

  console.log(chatlist, "chatlist");

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    (async () => {
      await dispatch(profileAll()).catch((error) => {
        console.error("Failed to fetch profiles.");
      });
    })();
  }, [dispatch]);

  const { profile } = useSelector((state) => state.dashboardSlice);

  useEffect(() => {
    if (profile) {
      setData(profile.data);
      // setFilteredData(profile.data);
    }
  }, [profile]);

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    if (query === "") {
      setFilteredData(" ");
      return;
    }

    const filtered = data.filter(
      (item) =>
        item.member_name?.toLowerCase().includes(query) ||
        item.company_name?.toLowerCase().includes(query)
    );

    setFilteredData(filtered);
  };

  const handleSelect = (item) => {
    setAcknowledgedMessages((prev) => [...prev, item.member_id]);
    setActiveChatId(item.member_id); // Update active chat ID
    onSelectMember(item);
    setvisiblesearch(false);
  };

  return (
    <div className="discussions-section border border-grey">
      <div className="search mt-2 mb-4" ref={visibleref}>
        <div className="search-bar ">
          <i className="fa fa-search ms-2 me-1" aria-hidden="true"></i>
          <input
            type="text"
            placeholder="Search by name or company..."
            value={searchQuery}
            onChange={handleSearch}
            onFocus={() => setvisiblesearch(true)}
          />
        </div>
        {visiblesearch && (
          <ul
            className="list-group mt-3"
            id="searchResults"
            style={{
              maxHeight: "300px",
              overflowY: "auto",
              overflowX: "hidden",
              border: "1px solid #ddd",
              padding: "0",
            }}
          >
            {Array.isArray(filteredData) &&
              filteredData.map((item, index) => (
                <li
                  key={index}
                  className="list-group-item"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSelect(item)}
                >
                  <div className="desc-contact">
                    <p className="name mb-0">{item.member_name}</p>
                    <p className="message">{item.company_name}</p>
                  </div>
                </li>
              ))}
          </ul>
        )}
      </div>

      {chatlist?.map((list, index) => (
        <div
          key={index}
          className={`discussion ${
            activeChatId === list.member_id ? "active-chat" : ""
          } mt-2`}
          onClick={() => handleSelect(list)}
        >
          <div
            className="photo"
            style={{
              backgroundImage: `url(${list?.member_logo || "/dumy.jpeg"})`,
            }}
          >
            <div className="online"></div>
          </div>
          <div className="desc-contact">
            <p className="name mb-0">{list.member_name}</p>
          </div>
          {list.unread_count === 1 &&
            !acknowledgedMessages.includes(list.member_id) && (
              <div className="timer  text-danger ">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="bounce-animation me-1"
                />
                New Message
              </div>
            )}
        </div>
      ))}
    </div>
  );
};

export default ChatSidebar;
